package com.appsyde.shared.modules.ai.domain

/**
 * Thrown when POST /ai/generate returns 409 (extract RUNNING).
 * Caller can retry after a delay until the server has finished the extract.
 */
class AiExtractRunningException(
    message: String? = null,
    cause: Throwable? = null,
) : Exception(message ?: "AI extract already running (409)", cause)
